import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

function trackPageView(path, title) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
    });
  }
}

export default function AnalyticsListener() {
  const location = useLocation();
  const lastPathRef = useRef(null); // avoids duplicate events in React 18 dev

  useEffect(() => {
    const path = location.pathname;
    if (lastPathRef.current !== path) {
      trackPageView(path, document.title);
      lastPathRef.current = path;
    }
  }, [location]);

  return null;
}
